import * as React from 'react';
import classNames from 'classnames';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
import CheckCircleFilled from '@ant-design/icons/CheckCircleFilled';
import ExclamationCircleFilled from '@ant-design/icons/ExclamationCircleFilled';
import Col from '../grid/col';
import { FormContext, FormItemPrefixContext } from './context';
import ErrorList from './ErrorList';
const iconMap = {
    success: CheckCircleFilled,
    warning: ExclamationCircleFilled,
    error: CloseCircleFilled,
    validating: LoadingOutlined,
};
const FormItemInput = props => {
    const { prefixCls, status, wrapperCol, children, errors, warnings, hasFeedback, _internalItemRender: formItemRender, validateStatus, extra, help, } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = React.useContext(FormContext);
    const mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
    const className = classNames(`${baseClassName}-control`, mergedWrapperCol.className);
    // Should provides additional icon if `hasFeedback`
    const IconNode = validateStatus && iconMap[validateStatus];
    const icon = hasFeedback && IconNode ? (<span className={`${baseClassName}-children-icon`}>
        <IconNode />
      </span>) : null;
    // Pass to sub FormItem should not with col info
    const subFormContext = React.useMemo(() => (Object.assign({}, formContext)), [formContext]);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    const inputDom = (<div className={`${baseClassName}-control-input`}>
      <div className={`${baseClassName}-control-input-content`}>{children}</div>
      {icon}
    </div>);
    const formItemContext = React.useMemo(() => ({ prefixCls, status }), [prefixCls, status]);
    const errorListDom = (<FormItemPrefixContext.Provider value={formItemContext}>
      <ErrorList errors={errors} warnings={warnings} help={help} helpStatus={status} className={`${baseClassName}-explain-connected`}/>
    </FormItemPrefixContext.Provider>);
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? <div className={`${baseClassName}-extra`}>{extra}</div> : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? (formItemRender.render(props, { input: inputDom, errorList: errorListDom, extra: extraDom })) : (<>
        {inputDom}
        {errorListDom}
        {extraDom}
      </>);
    return (<FormContext.Provider value={subFormContext}>
      <Col {...mergedWrapperCol} className={className}>
        {dom}
      </Col>
    </FormContext.Provider>);
};
export default FormItemInput;
